import DetailsTitle from "components/common/detailsPage/DetailsTitle";
import DetailsShimmer from "components/common/shimmer/DetailsShimmer";
import { CustomerStatusBadge } from "components/common/StatusBadge";
import { usePermission } from "hooks/usePermission";
import { useQueryParam } from "hooks/useQueryParam";
import React, { useEffect, useState } from "react";
import { Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { getCustomerDetails } from "store/slices/customersSlice";
import { formatUTCDate } from "utils/utils";
import Vehicles from "./Vehicles";
import Transactions from "./Transactions";
import Membership from "./Membership";
import InfoItem from "components/common/detailsPage/InfoItem";
import NoPermission from "components/common/NoPermission";
import AppliedCouponsHistory from "pages/Coupons/ApplliedCouponsHistory";

const CustomerDetails = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const id = useQueryParam("id");

  const { canAction } = usePermission();
  const { canView } = canAction("customers");

  const { loading, itemDetails } = useSelector((state) => state.Customers);

  const { name, phone, status, lastLoggedIn, createdAt, deviceInfo } =
    itemDetails || {};
  const {
    appVersion,
    fcmToken,
    language: deviceLanguage,
    model,
    osVersion,
    platform,
  } = deviceInfo || {};

  const [activeTab, setActiveTab] = useState(1);

  useEffect(() => {
    if (id && canView) {
      dispatch(getCustomerDetails(id));
    }
  }, [id, canView]);

  const TABS = [
    { id: 1, label: "Vehicles" },
    { id: 2, label: "Transactions" },
    { id: 3, label: "Memberships" },
    { id: 4, label: "Applied Coupons" },
  ];

  const infoFields = [
    {
      label: t("Name"),
      value: name,
      col: { lg: 2, md: 3 },
    },
    {
      label: t("Phone Number"),
      value: phone,
      col: { lg: 2, md: 3 },
    },
    {
      label: t("Last Login Date"),
      value: lastLoggedIn ? formatUTCDate(lastLoggedIn) : "-",
      col: { lg: 2, md: 3 },
    },
    {
      label: t("Created Date"),
      value: createdAt ? formatUTCDate(createdAt) : "-",
      col: { lg: 2, md: 3 },
    },
    {
      label: t("Status"),
      render: <CustomerStatusBadge status={status} t={t} />,
      col: { lg: 2, md: 3 },
    },
    {
      label: t("App Version"),
      value: appVersion,
      col: { lg: 2, md: 3 },
    },

    { isSpacer: true },

    {
      label: t("Language"),
      value: deviceLanguage,
      col: { lg: 2, md: 3 },
    },
    {
      label: t("Model"),
      value: model,
      col: { lg: 2, md: 3 },
    },
    {
      label: t("OS Version"),
      value: osVersion,
      col: { lg: 2, md: 3 },
    },
    {
      label: t("Platform"),
      value: platform,
      col: { lg: 2, md: 3 },
    },
  ];
  const shimmerLayout = [
    {
      col: 12,
      blocks: [
        { rows: 1, cols: 6 },
        { rows: 1, cols: 5 },
      ],
    },
    {
      col: 12,
      blocks: [{ rows: 1, cols: 3 }],
    },
    {
      col: 12,
      type: "details_page_tab",
      blocks: [{ rows: 1, cols: 1 }],
    },
  ];

  if (!canView) return <NoPermission />;

  if (loading) {
    return (
      <div className="page-content">
        <DetailsTitle title={t("Customer Details")} />
        <DetailsShimmer layout={shimmerLayout} />
      </div>
    );
  }

  return (
    <div className="page-content common_details_page customer_details">
      <DetailsTitle title={t("Customer Details")} />
      <div className="common_card">
        <h2 className="title_20 mb-4">{t("General Details")}</h2>
        <Row>
          {infoFields.map((item, index) => {
            if (item.isSpacer) {
              return <div key={index} className="mt-4 w-100" />;
            }

            return (
              <InfoItem
                key={index}
                label={item.label}
                value={item.value}
                col={item.col}
              >
                {item.render}
              </InfoItem>
            );
          })}
        </Row>
      </div>
      <div className="common_tabs mt_20">
        {TABS.map((tab) => (
          <button
            key={tab?.id}
            className={`tabs_btn ${activeTab === tab?.id ? "active" : ""}`}
            onClick={() => setActiveTab(tab.id)}
          >
            {t(tab.label)}
          </button>
        ))}
      </div>
      <div className="common_card mt_20 p-0">
        {activeTab === 1 && <Vehicles id={id} />}
        {activeTab === 2 && <Transactions id={id} />}
        {activeTab === 3 && <Membership id={id} />}
        {activeTab === 4 && <AppliedCouponsHistory userId={id} isFromUserDetails={true} />}
      </div>
    </div>
  );
};

export default CustomerDetails;
